import React from 'react';
import { useTrussStore } from '../../hooks/useTrussManagement';

export const TrussTool: React.FC = () => {
  const { activeTool, setActiveTool } = useTrussStore();

  const handleClick = () => {
    console.log('🔧 Truss tool clicked, current state:', activeTool);
    setActiveTool(!activeTool);
    console.log('🔧 Truss tool new state:', !activeTool);
  };

  return (
    <button
      className={`px-3 py-1 text-sm rounded-md transition-colors ${
        activeTool
          ? 'bg-purple-600 text-white'
          : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
      }`}
      onClick={handleClick}
      title="Create Truss (T)"
    >
      <span className="flex items-center">
        <span className="mr-1">⟲</span> Truss
      </span>
    </button>
  );
};
